// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__6Ppor","title":"ClientReferral_title__1Vry-","itemText":"ClientReferral_itemText__19aaL"};